// Local Storage Keys
export const TOUR_DIALOG_KEY = 'pl-explorer-tour';
export const FEATURES_STORE_KEY = 'pl-feature-highlights';
export const LABS_KEY = 'pl_lab_features';
export const SETTINGS_KEY = 'pl-settings-store';
export const SPECTRAL_INDICES_KEY = 'pl-spectral-indexes';
